import PropTypes from 'prop-types';
import './LoadingMessage.css';


LoadingChatAIMessage.propTypes = {
    displayedMessages: PropTypes.object
};

export default function LoadingChatAIMessage({ displayedMessages }) {

    return (
        <div className="loading-message">
            <div className="loading-message-content">{displayedMessages}  <div className="dot-chatbot dot--one"></div>
                <div className="dot-chatbot dot--two"></div>
                <div className="dot-chatbot dot--three"></div></div>
        </div>
    );
}
